import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import PrimaryButton from "../../elements/primary-button";
import Carousel from "../../sections/carousel";
import { gtag } from "../../utils";
import "./style.scss";

const FunPrint = ({ fields, rendering, page }) => {
  const { items, headingBody, headingType, overlineText, subheadingBody, subheadingType } = fields;
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [pagination, setPagination] = useState({ index: 0, page: 1 });
  const [funPrintMedia, setFunPrintMedia] = useState(items[pagination.index].fields);
  // preload images
  useEffect(() => {
    items.forEach(item => {
      const img = new Image();
      img.src = item.fields.poster.value.src;
      window[img.src] = img;
    });
  }, [items]);

  useEffect(() => {
    !isFirstLoad &&
      setFunPrintMedia({
        ...items[pagination.index].fields
      });
    setIsFirstLoad(false);
  }, [pagination.index]);

  const handlePreviousPage = () => {
    const { index, page } = pagination;
    // Jump to end if first page
    setPagination({
      index: page === 1 ? items.length - 1 : index - 1,
      page: page === 1 ? items.length : page - 1
    });
  };

  const handleNextPage = () => {
    gtag('event', 'Component_info', {
      'component_name': 'FunPrint',
      'page_title': page?.name
    });
    const { index, page } = pagination;
    // Jump to beginning if last page
    setPagination({
      index: page === items.length ? 0 : index + 1,
      page: page === items.length ? 1 : page + 1
    });
  };
  return (
    <div className="fun-print" datasourceid={rendering.dataSource}>
      <div className="grid">
        <FunPrintHeader
          {...{
            overlineText: overlineText.value,
            heading: headingBody,
            headingType: headingType,
            subHeading: subheadingBody,
            subHeadingType: subheadingType
          }}
        />
      </div>

      <div className="carousel-container grid">
        <Carousel onPrev={handlePreviousPage} onNext={handleNextPage}>
          <FunPrintMedia {...funPrintMedia} />
        </Carousel>
        {funPrintMedia && <FunPrintContent {...items[pagination.index].fields} page={pagination.page} maxPages={items.length} />}
      </div>
    </div>
  );
};

FunPrint.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    items: PropTypes.array,
    headingBody: PropTypes.object,
    headingType: PropTypes.object,
    overlineText: PropTypes.object,
    subheadingBody: PropTypes.object,
    subheadingType: PropTypes.object
  })
};

export default FunPrint;

const FunPrintHeader = ({ overlineText, heading, headingType, subHeading, subHeadingType }) => (
  <div className="fun-print-header">
    {overlineText && <div className="overline">{overlineText}</div>}
    <Heading className="heading" typographyClass="type-h1" html={heading} type={headingType} />
    <Heading className="sub-heading" typographyClass="type-h4" html={subHeading} type={subHeadingType} />
  </div>
);

const FunPrintMedia = ({ video, poster, onNext }) => (
  <>
    {video && (
      <div key={video.value.displayName} className="media-container">
        <video muted={true} onClick={onNext} autoPlay={true} loop={true} playsInline={true} className="media" poster={poster.value.src}>
          <source src={video.value.src} type={video.value.mimeType} />
        </video>
      </div>
    )}
  </>
);

const FunPrintContent = ({ headingBody, headingType, body, CTA, page, maxPages }) => (
  <div className="fun-print-content">
    <motion.div key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <div className="story">
        <span className="overline">{`${page}/${maxPages}`}</span>
        <Heading html={headingBody} type={headingType} className="heading" typographyClass="type-h3" />
        <BodyText html={body.value} />
        <PrimaryButton {...CTA.fields} />
      </div>
    </motion.div>
  </div>
);
